import {
  getColumnIndexName,
  getColumnConditionalFormat,
  getColumnIndex,
} from '../../../../components/gsheet';


function getCellInRow(table_header, header_name) {
  const column_index_name = getColumnIndexName(table_header, header_name);
  return `INDIRECT(CONCAT("${column_index_name}", ROW()))`;
}

function buildFormat(table_header, column_name, custom_condition) {
  const format = getColumnConditionalFormat(
    getColumnIndex(table_header, column_name),
    {
      "type": "CUSTOM_FORMULA",
      "values": [
        {
          "userEnteredValue": ('=' + custom_condition),
        }
      ]
    },
    {
      "backgroundColor": {
        "green": 0.2,
        "red": 0.8,
      }
    }
  );

  return format;
}

export function conditionalFormatNumberColumn(
  table_header, column_name, rules) {

  const gene_cell_in_row = getCellInRow(table_header, 'Gene');
  const column_cell_in_row = getCellInRow(table_header, column_name);

  let switch_args = [gene_cell_in_row];
  for (const [gene, threshold] of Object.entries(rules)) {
    switch_args.push(`"${gene}"`);
    switch_args.push('' + threshold);
  }
  const switch_clause = `SWITCH(${switch_args.join(',')})`;

  const condition = `GT(${column_cell_in_row}, ${switch_clause})`;

  const format = buildFormat(table_header, column_name, condition);

  return format;
}

export function conditionalFormatRangeColumn(
  table_header, column_name, rules) {

  const gene_cell_in_row = getCellInRow(table_header, 'Gene');
  const column_cell_in_row = getCellInRow(table_header, column_name);
  const switch_args = [gene_cell_in_row];

  const lower_value = `INDEX(SPLIT(${column_cell_in_row}, "=>"), 0, 1)`;
  const upper_value = `INDEX(SPLIT(${column_cell_in_row}, "=>"), 0, 2)`;

  for (const [
    gene, [lower_threshold, upper_threshold]
  ] of Object.entries(rules)) {

    switch_args.push(`"${gene}"`);

    const lower_predict = `GT(${lower_value}, ${lower_threshold})`;
    const upper_predict = `LT(${upper_value}, ${upper_threshold})`;

    switch_args.push(
      `OR(${lower_predict}, ${upper_predict})`
    );
  }

  const condition = `SWITCH(${switch_args.join(',')})`;

  const format = buildFormat(table_header, column_name, condition);

  return format;
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/gtable_seq/format.js